import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { NavLink, withRouter } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const navItems = [{
  label: 'menu.dashboard',
  link: '/dashboard',
  deniedRoles: [],
  showNotificationWithActionsCounter: true
}, {
  label: 'menu.projects',
  link: '/projects',
  deniedRoles: []
}, {
  label: 'menu.requests',
  link: '/requests'
}, {
  label: 'menu.users',
  link: '/users'
}, {
  label: 'menu.organisation',
  link: '/organisation'
}];
export const NavView = props => {
  const isLinkActive = link => {
    return () => props.location.pathname.startsWith(link.substring(0, link.length - 1));
  };
  const renderNavItems = () => {
    return navItems.map((item, index) => {
      const navLink = /*#__PURE__*/_jsx(NavLink, {
        "data-id": `link-${index}`,
        to: item.link,
        isActive: isLinkActive(item.link),
        children: /*#__PURE__*/_jsx("div", {
          className: "badge-container",
          children: /*#__PURE__*/_jsx(Translate, {
            value: item.label
          })
        })
      });
      return /*#__PURE__*/_jsx(React.Fragment, {
        children: navLink
      }, index);
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: "nav-container",
    children: /*#__PURE__*/_jsx("nav", {
      children: renderNavItems()
    })
  });
};
NavView.propTypes = {
  location: PropTypes.object.isRequired
  // notifications: PropTypes.object.isRequired
};
export default withRouter(NavView);